const radioButtonBoxTokens = ({
  borders,
  colors,
  colorsBrand,
  lineHeights,
  fontSizeBody,
  fontWeights,
}) => ({
  borders: borders[2],
  colors: {
    label: colors.neutrals[2],
    tick: {
      default: {
        iconColor: colors.white,
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.neutrals[5],
        },
      },
      error: {
        iconColor: colors.critical.dark,
        bgColor: colors.critical.light,
        labelColor: colors.critical.default,
        borderColor: colors.critical.default,
      },
      disabled: {
        iconColor: colors.neutrals[2],
        bgColor: colors.neutrals[5],
        borderColor: colors.neutrals[5],
      },
      checked: {
        iconColor: colorsBrand[1],
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.neutrals[5],
        },
      },
    },
    circle: {
      default: {
        iconColor: colors.white,
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.neutrals[5],
        },
      },
      error: {
        iconColor: colors.critical.dark,
        bgColor: colors.critical.light,
        labelColor: colors.critical.default,
        borderColor: colors.critical.default,
      },
      disabled: {
        iconColor: colors.neutrals[2],
        bgColor: colors.neutrals[5],
        borderColor: colors.neutrals[5],
      },
      checked: {
        iconColor: colorsBrand[1],
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.neutrals[5],
        },
      },
    },
  },
  sizes: {
    minWidth: '20px',
    height: '20px',
  },
  lineHeight: lineHeights.body,
  fontSizes: fontSizeBody[1],
  fontWeights: {
    unchecked: fontWeights.normal,
    checked: fontWeights.medium,
  },
});

export default radioButtonBoxTokens;
